/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {TimeModule as ɵb} from './lib/pipe/time.module';
export {TimePipe as ɵa} from './lib/pipe/time.pipe';